import { db, FieldValue } from 'helpers/firebase';
import { NOTIFICATION_TYPE } from 'constants/notification';
import { ROLES } from 'constants/user';

const serverTimestamp = FieldValue.serverTimestamp;

export const getNotificationsRef = (uid) => {
  const ref = db
    .collection(`/users/${uid}/notifications`)
    .orderBy("created_at", "desc")
    .limit(20);
  return ref;
}

export const readNotification = (uid, notification_id) => {
  const ref = db
    .doc(`/users/${uid}/notifications/${notification_id}`);
  return ref.update({ read_at: serverTimestamp() });
}

export const readAllNotifications = (uid) => {
  const ref = db
    .collection(`/users/${uid}/notifications`)
    .where("read_at", "==", null);
  return ref
    .get()
    .then(colSnap => colSnap.docs.forEach(doc => doc.ref.update({ read_at: serverTimestamp() })));
}
